import { render, staticRenderFns } from "./BackToIcon.vue?vue&type=template&id=c7dc991a&"
import script from "./BackToIcon.vue?vue&type=script&lang=js&"
export * from "./BackToIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports